module.exports = __webpack_public_path__ + "static/media/ovest2.27a04ae2.svg";